import {ContactWidth} from "./CommonWidths";
import {AmountTdWidth} from "./AmountTd";

export const contactNameCellStyle = {
    ellipsis: true,
    width: ContactWidth,
    sorter: true,
};

export const contactNameProps = () => ({
    dataIndex: 'contact_name',
    ...contactNameCellStyle,
});

export const amountProps = {
    align: 'right',
    width: AmountTdWidth,
    ellipsis: true,
};
